/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCredentials
 */
export interface UserCredentials {
    /**
     * 
     * @type {string}
     * @memberof UserCredentials
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserCredentials
     */
    password: string;
}

/**
 * Check if a given object implements the UserCredentials interface.
 */
export function instanceOfUserCredentials(value: object): value is UserCredentials {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function UserCredentialsFromJSON(json: any): UserCredentials {
    return UserCredentialsFromJSONTyped(json, false);
}

export function UserCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCredentials {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function UserCredentialsToJSON(json: any): UserCredentials {
    return UserCredentialsToJSONTyped(json, false);
}

export function UserCredentialsToJSONTyped(value?: UserCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'password': value['password'],
    };
}

